import React, { useContext, useState, useEffect, useMemo, useCallback } from "react";

import Table from "../../../Components/Table/Table";

import { helpers } from "@acadia-ui/theme";

import DataStore from "../../../Flux/Stores/InsertionOrderDataStore";
import { fetchInsertionOrders } from "../../../Flux/Actions/InsertionOrderActions";
import LegacyInsertionOrderView from "../features/LegacyViews/LegacyInsertionOrder";
const classNameComponent = `gos-workbook__auditlevel-insertionOrder`;
const classNamePrefix = `${classNameComponent}__`;

export default function useInsertionOrder({
	// this comment exists to prevent eslint from making this unreadable.
	auditLevel,
	parentCampaignUniqueID,
	metaData,
	auditLevels,
	fetchMetaData,
	navigateToLineItems
}) {
	const [data, setData] = useState();
	const [config, setConfig] = useState();

	useEffect(() => {
		setData(null);
		setConfig(null);
	}, [parentCampaignUniqueID]);

	const refresh = useCallback(async (parentCampaignUniqueID, auditLevel) => {
		if (parentCampaignUniqueID && auditLevel) {
			try {
				await fetchInsertionOrders(
					{
						platform: { value: auditLevel.PlatformID },
						auditlevel: { value: auditLevel.AuditLevelID }
					},
					parentCampaignUniqueID
				);
				setData(DataStore.getData());
				setConfig(DataStore.getConfig());
			} catch (e) {
				setData(null);
				setConfig(null);
			}
		}
	}, []);

	helpers.useAsyncEffect(() => {
		if (parentCampaignUniqueID && auditLevel && metaData.CampaignUniqueIDCode == parentCampaignUniqueID && auditLevel.PlatformID == metaData.PlatformID) {
			refresh(parentCampaignUniqueID, auditLevel);
		}
	}, [parentCampaignUniqueID, auditLevel]);

	const Component = useCallback(
		({ refreshMap }) => {
			if (data && config && metaData && fetchMetaData) {
				return (
					<div className={`gos-workbook__auditlevel ${classNameComponent}`}>
						{/* <Table
                        data={data}
                        config={config}
                        hierarchyLevel="Package"
                        metaData={metaData}
                        // TODO
                        // isEditing={!this.state.readOnly}
                        updateSelected={() => {}}
                        refreshData={() => {}}
                        // updateSelected={this.numberSelected}
                        // refetchData={this.refetchPackages}
                        navigateToChild={() => {}}
                        // Line Item specific props and extra columns
                        syncAPI={metaData && metaData.SyncIcon === "True"}
                        // extraColumns={this.state.extraColumns}
                    /> */}

						<LegacyInsertionOrderView
							campaignMetaData={metaData}
							navigateToLineItems={navigateToLineItems}
							auditLevelData={auditLevels}
							getCount={() => {}}
							getPlacementCount={() => {}}
							updateCounts={async () => {
								// ["InsertionOrder", "LineItem"].forEach((name) => refreshMap?.[name]?.());
								await refreshMap?.InsertionOrder?.();
								await refreshMap?.LineItem?.();
							}}
							updateMetaData={fetchMetaData}
						/>
					</div>
				);
			}
			return <></>;
		},
		[config, data, fetchMetaData, metaData]
	);

	return useMemo(
		() => ({
			Component,
			data,
			refresh
		}),
		[Component, data, refresh]
	);
}
